import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { i18n } from "../plugins/i18n.js";

import Setup from "../views/Setup";
import Start from "../views/Start";
import AbsenceOverview from "../components/Administration/UserAbsencesAdministration";
import Administration from "../views/Administration";
import Login from "../views/Login";
import MainMenu from "../views/MainMenu";
import PresenceList from "../views/PresenceList";
import ManualTimekeeping from "../views/ManualTimekeeping.vue";
import Settings from "../components/Administration/Settings";
import TimeReports from "../components/Administration/TimeReports";
import UserGroup from "../components/Administration/UserGroups";
import EventLogs from "../components/Administration/EventLogs.vue";
import UserAdministration from "../components/Administration/UserAdministration";
import ProjectManagement from "../components/Administration/ProjectManagement";
import ServiceCallManagement from "../components/Administration/ServiceCallManagement";

import WorkTimeReport from "../views/GeneralReporting/WorkTimeReport";
import AbsenceReport from "../views/GeneralReporting/AbsenceReport";

Vue.use(VueRouter);

/* Used for re-routing when accessing administrative pages as an ordinary user */
const protectedRoutesAdm = [EventLogs, Administration, Settings, UserAdministration, UserGroup];

const protectedRoutesMgmt = [ProjectManagement, ServiceCallManagement];

const protectedRoutesTimeReport = [WorkTimeReport, AbsenceReport, TimeReports];

const protectedRoutesAbs = [AbsenceOverview];

const publicRoutes = [Setup, Start, Login, MainMenu, PresenceList, ManualTimekeeping];

const allRoutes = [...protectedRoutesAdm, ...publicRoutes, ...protectedRoutesMgmt, ...protectedRoutesTimeReport, ...protectedRoutesAbs];

const Router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "*",
      redirect: { name: "Login" }
    },
    ...allRoutes.map((route) => ({
      path: "/" + route.route,
      name: route.name,
      component: route
    }))
  ]
});

Router.beforeEach((to, from, next) => {
  const userRights = store.state.user.user.userGroupRights;
  const {
    canAccessUserAdministration,
    canAccessAbsenceOverview,
    canAccessAbsenceOverviewTeam,
    canAccessManagement,
    canAccessGeneralReporting,
    canAccessGeneralReportingTeam
  } = userRights;
  const isProtectedRoute = protectedRoutesAdm.some((route) => route.name === to.name);

  if (!canAccessUserAdministration && isProtectedRoute && store.state.user.user.SAPEmpId !== "0000") {
    /* from is possibly null here */
    return next({ name: from?.name ?? MainMenu.name });
  }

  if (!canAccessAbsenceOverview && protectedRoutesAbs.some((route) => route.name === to.name) && !canAccessAbsenceOverviewTeam)
    return next({ name: from?.name ?? MainMenu.name });

  if (!canAccessManagement && protectedRoutesMgmt.some((route) => route.name === to.name)) return next({ name: from?.name ?? MainMenu.name });

  if (!canAccessGeneralReporting && protectedRoutesTimeReport.some((route) => route.name === to.name) && !canAccessGeneralReportingTeam)
    return next({ name: from?.name ?? MainMenu.name });

  if (store.state.language.language && store.state.language.language !== i18n.locale) {
    i18n.locale = store.state.language.language;
  } else if (!store.state.language.language) {
    store.dispatch("language/setLanguage", navigator.languages).then(() => {
      i18n.locale = store.state.language.language;
    });
  }

  next();
});

export default Router;
